import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { PillsWrapper } from './styles';

type PillsType = {
  children: ReactNode;
} & ComponentPropsWithoutRef<'div'>;

export const Pills = ({ children, ...rest }: PillsType) => {
  return <PillsWrapper {...rest}>{children}</PillsWrapper>;
};
